/**
 * Class to manage custom scrolling, as insipred by https://tympanus.net/Development/ColumnScroll/
 */
class CustomScroll {

    constructor(el) {
        this.el = el;
        this.initColumns();
        this.initColumnMatrices();
        this.initScrollWatch();
        this.el.classList.add('ready');
    }

    /**
     * Creates an array explaining the columns.  Each array element contains:
     * @prop col {HTMLElement} - The html element of the column
     * @prop isReverse {Boolean} - If the column should scroll in the reverse direction
     * @prop min {Number} - The minimum "y" coords that the column can scroll to
     * @prop max {Number} - The maximum "y" coords that the column can scroll to
     */
    initColumns() {
        const columns = [ ...this.el.querySelectorAll('.custom-scroll-column') ].map(col => {
            const isReverse = col.dataset.hasOwnProperty('colReverse');
            const overflow = col.offsetHeight - this.el.offsetHeight;
            const min = !isReverse ? -(overflow) : this.getMatrixY(col);
            const max = isReverse ? -(overflow) : 0;
            return { col, isReverse, min, max };
        });

        this.columns = Object.freeze(columns);
    }

    /**
     * Updates the column's matrix
     * @param {HTMLElement} colEl - The HTML element of the column
     * @param {Number} y - The new y coords
     */
    setMatrixY(colEl, y) {
        colEl.style.transform = `matrix(1,0,0,1,0,${y})`;
    }

    /**
     * Pulls the current y coords from the column's transform:matrix style declaration
     * @param {*} col 
     * @returns {Number} - the current y coords of the column
     */
    getMatrixY(col) {
        const style = window.getComputedStyle(col);
        const transform = style.transform;
        const [ fm, plots ] = transform.match(/\((.*)\)$/);
        const matrix = plots.split(',').map(v => v.trim());
        const y = matrix[matrix.length - 1];
        return parseFloat(y);
    }

    /**
     * Updates the transform matrix of the columns on load. Odd indices should start at the bottom.
     */
    initColumnMatrices() {
        this.columns.forEach(({ col }, idx) => {
            if( idx % 2 === 0 ) {
                const overflow = col.offsetHeight - this.el.offsetHeight;
                this.setMatrixY(col, -(overflow));
            }
        });
    }

    /**
     * 
     * @param {Number} deltaY - The amount to scroll the column by
     * @param {Object} columnElement - The array element representation of the column 
     */
    updateColumnMatrixOnScroll( deltaY, { col, min, max, isReverse } ) {
        const yAsInt = this.getMatrixY(col);
        let newY = yAsInt;

        if( isReverse ) {
            const target = yAsInt - deltaY;

            if( target >= max && target <= min ) {
                newY = target;
            }
        } else {
            const target = yAsInt + deltaY;

            if( target <= max && target >= min ) {
                newY = target;
            }
        }

        if( newY !== yAsInt ) {
            this.setMatrixY(col, newY);
        }
    }

    /**
     * Setup event listeners to manage scrolling
     */
    initScrollWatch() {
        this.el.addEventListener('mousewheel', ({ deltaY }) => {
            this.columns.forEach(col => this.updateColumnMatrixOnScroll( deltaY, col ));
        });
    }

    /**
     * Find all possible containers adn start the functionality
     */
    static init() {
        const elements = [ ...document.querySelectorAll('.custom-scroll') ];
        elements.forEach(el => new CustomScroll( el ));
    }

}

export default CustomScroll;